import cusdc from './cusdc.svg'
import ibeth from './ibeth.png'
import xsushi from './xsushi.png'
import yusd from './yusd.png'
import imusd from './imusd.svg'
import steth from './steth.png'

export default { cusdc, ibeth, xsushi, yusd, imusd, wsteth: steth }
